export default {"id":"5058f60a","attrs":{"viewBox":"0 0 28 28","width":"24","height":"24"}}